import { useHead } from "#imports";
import { useSchemaOrgConfig } from "../utils/config.js";
export function useSchemaOrg(input) {
  const config = useSchemaOrgConfig();
  const script = {
    type: "application/ld+json",
    key: "schema-org-graph",
    // @ts-expect-error untyped
    nodes: input,
    tagPriority: "high",
    ...config.scriptAttributes
  };
  if (import.meta.dev) {
    return useHead({
      script: [script]
    });
  }
  if (import.meta.server) {
    return useHead({
      script: [script]
    });
  } else if (config?.reactive) {
    return useHead({
      script: [script]
    });
  }
}
